import React, { useState, useEffect, useRef } from 'react';
import { ListView, PullToRefresh } from 'antd-mobile';
import { getUser } from '@/utils';

const StatisticsList = (props) => {
  const dataS = new ListView.DataSource({
    getRowData: (dataBlob, sectionID, rowID) => {
      return dataBlob[sectionID][rowID];
    },
    rowHasChanged: (row1, row2) => row1 !== row2,
  });
  const { param: _param, timers, pageSize, func, ...other } = props;

  const [pageIndex, setIndex] = useState(0);
  const [refreshing, setRefreshing] = useState(false);
  const [dataSource, setDataSource] = useState(dataS);
  const [hasMore, setHasMore] = useState(false);
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);
  const listRef = useRef();

  const getList = async function (page) {
    const { deptId } = getUser() || {};
    setLoading(true);
    const param = {
      ..._param,
      current: page,
      size: pageSize,
      deptId,
      startTime: timers.startTime,
      endTime: timers.endTime,
    };
    let data = [];
    const respMenu = await func(param);
    if (respMenu.success && respMenu.data && respMenu.data.records.length !== 0) {
      data = respMenu.data.records;
      setHasMore(respMenu.data.current < respMenu.data.pages);
    }
    if (page !== 1) {
      data = [...list, ...data];
    }
    setLoading(false);
    setRefreshing(false);
    setList(data);
    setDataSource(dataSource.cloneWithRows(data));
    setIndex(page);
  };

  const onEndReached = () => {
    if (!loading && hasMore) {
      getList(pageIndex + 1);
    }
  };

  useEffect(() => {
    if (timers && JSON.stringify(timers) !== '{}') {
      getList(1);
    }
  }, [timers]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <ListView
      ref={listRef}
      dataSource={dataSource}
      renderHeader={() => null}
      renderFooter={() => (
        <div style={{ padding: '5vw', textAlign: 'center' }}>
          {hasMore ? (loading ? '加载中...' : '加载完成') : '没有更多'}
        </div>
      )}
      className="supervisor-statistics-content"
      pageSize={pageSize}
      scrollRenderAheadDistance={100}
      onEndReached={onEndReached}
      onEndReachedThreshold={10}
      pullToRefresh={
        <PullToRefresh
          refreshing={refreshing}
          onRefresh={() => {
            setRefreshing(true);
            getList(1);
          }}
        />
      }
      {...other}
    />
  );
};

export default StatisticsList;
